import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

/**
 * Story E01.12 AC-12 — 404 placeholder.
 *
 * Wired into TanStack Router as the `notFoundComponent` of the root
 * route. Deliberately a thin skeleton; full empty-state styling lands
 * in a later epic once `<EmptyState>` ships.
 */
export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-3xl font-semibold">404</h1>
      <p className="text-muted-foreground">{t('errors.not_found')}</p>
      <Link
        to="/"
        className="rounded-md border border-border bg-bg px-4 py-2 text-sm font-medium hover:bg-accent"
      >
        {t('errors.go_home')}
      </Link>
    </div>
  )
}
